import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { useI18n } from "../lib/i18n";
import { useAuth, API } from "../lib/auth";
import { Loader2 } from "lucide-react";

export default function LoginPage() {
  const { t } = useI18n();
  const { setSession } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ identifier: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await axios.post(`${API}/auth/login`, form);
      setSession(r.data.token, r.data.user);
      toast.success("Welcome back!");
      const u = r.data.user;
      let dest = "/candidate";
      if (u.role === "admin") dest = "/admin";
      else if (u.role === "employer") {
        dest = (u.status || "active") === "active" ? "/employer" : "/pending-approval";
      }
      navigate(dest);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <Card className="p-8" data-testid="login-card">
        <h1 className="font-display text-3xl font-bold text-slate-900 mb-2">{t("auth.loginTitle")}</h1>
        <p className="text-sm text-slate-500 mb-6">Motravay</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="li-id">{t("auth.identifier")}</Label>
            <Input id="li-id" data-testid="login-identifier" required value={form.identifier} onChange={(e) => setForm({ ...form, identifier: e.target.value })} />
          </div>
          <div>
            <Label htmlFor="li-pw">{t("auth.password")}</Label>
            <Input id="li-pw" data-testid="login-password" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
          </div>
          <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-[#1A8FE3] hover:bg-[#157AC0] text-white rounded-full">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : t("auth.login")}
          </Button>
        </form>
        <p className="text-sm text-slate-500 text-center mt-5">
          {t("auth.noAccount")} <Link to="/register" data-testid="link-signup" className="text-[#1A8FE3] font-medium">{t("auth.signup")}</Link>
        </p>
      </Card>
    </div>
  );
}
